// Show more upcoming course dates functions
var moreButton = document.querySelector('.course-occasions-box .read-more')
var openDoc = document.querySelector('.course-occasions-box .course-occasions')
var lessButton = document.querySelector('.course-occasions-box .read-less')
var box = document.querySelector('.course-occasions-box')
var dateLinks = document.querySelectorAll('.course-occasions-box .course-occasion')

if (moreButton){
  if (dateLinks.length < 4) {
      openDoc.classList.toggle('open')
      moreButton.classList.toggle('hide')  
  } else {
      box.classList.toggle('show-more-show')  

  }
}

if (moreButton){
  moreButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });

  lessButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });
}